export enum CASHIER_PAYMENT_METHODS_KEYS {
  ALL = 'all_cashier_payment_methods',
  PAYMENT_METHOD = 'cashier_payment_method',
  PAYMENT_METHOD_GROUPS = 'cashier_payment_method_groups',
  PAYMENT_METHOD_LOCALIZATION = 'cashier_payment_method_localization',
}

export const INITIAL_OFF_COLUMNS_CASHIER_PAYMENT_METHODS = [
  'cascadeRetryAttempts',
  'cascadeAfterTimeout',
  'displayNameLocales',
  'labelBeforeDepositLocales',
  'labelBeforeSubmitLocales',
  'labelUnderPaymentMethodLocales',
  'labelBeforeSubmitEnabled',
  'labelUnderPaymentMethodEnabled',
  'labelBeforeDepositEnabled',
  'metadataEqualsValues',
  'metadataNotEqualsValues',
  'metadataInValues',
  'metadataNotInValues',
  'metadataExist',
  'metadataNotExist',
];
